@if (!isPickerOnly) {
  <div class="check" *libIsHandset="desktopCheck">
    <span translate>clhqnrm43000008l6czokg68z</span>
    <mat-slide-toggle color="warn" (change)="changeList()"> </mat-slide-toggle>
  </div>
}
<ng-template #desktopCheck [formGroup]="check">
  <div class="check">
    <mat-slide-toggle
      color="warn"
      ngModel
      formControlName="checked"
      [disabled]="!(favList$ | async).current.length"
      (change)="changeList()"
      translate
      >clhqnrm43000008l6czokg68z
    </mat-slide-toggle>
  </div>
</ng-template>
@if (!isPickerOnly) {
  <div class="number">
    <h3>
      <span translate>clhswqfv5000108mf6y3zhpnr</span> {{ photoIdList.length }}/{{
      maxPhoto
      }}
    </h3>
  </div>
}
<lib-virtual-scroll
  [barOverContent]="true"
  [gridItemSize]="gridItemSize"
  [itemTpl]="item"
  [photos]="photosList$ | async"
  [targetHeight]="gridItemSize"
  type="grid"
  >
</lib-virtual-scroll>
<div class="buttons" *libIsHandset="desktopButton">
  <lib-button (click)="closeDialog.emit()" forceContext="common" translate
    >comeBack</lib-button
    >
    @if (productNotPackage) {
      <h3>
        {{
        product
        | priceWithConfigParser
        : (configuration | async)
        : photoIdList
        : "with file"
        : quantity
        : selectedProductId
        | async
        | pricePicker
        }}
      </h3>
    }
    @if (!swap) {
      <lib-button
        (click)="addProduct.emit(photoIdList)"
        forceContext="common"
        translate
        >save
      </lib-button>
    }
    @if (swap) {
      <lib-button (click)="swapPhoto()" forceContext="common" translate
        >save
      </lib-button>
    }
  </div>
  <ng-template #desktopButton>
    <div class="buttons">
      @if (productNotPackage) {
        <h2>
          {{
          product
          | priceWithConfigParser
          : (configuration | async)
          : photoIdList
          : "with file"
          : quantity
          : selectedProductId
          | async
          | pricePicker
          }}
        </h2>
      }
      @if (!isPickerOnly) {
        @if (!(isPhonePortrait$ | async) && !swap) {
          <lib-button
            (click)="addProduct.emit(photoIdList)"
            lg
            forceContext="productFront"
            translate
            >
            clhrdulje000008mqel629la6
          </lib-button>
        }
        @if (!(isPhonePortrait$ | async) && swap) {
          <lib-button
            (click)="swapPhoto()"
            lg
            forceContext="productFront"
            translate
            >
            clhrduqrj000108mqerma9y8b
          </lib-button>
        }
      } @else {
        <lib-button (click)="swapPhoto()" lg forceContext="common" translate>
          save
        </lib-button>
      }
      <ng-template #_isPickerOnly>
        <lib-button (click)="swapPhoto()" lg forceContext="common" translate>
          save
        </lib-button>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #item let-index let-photo>
    <div
      class="photo"
      [ngClass]="{ active: photo.photo.check }"
      (click)="checkPhoto(photo.photo.photoId)"
      >
      <lib-image-loader
        [isCover]="false"
      [url]="
        photo.photo
          | getImageUrl: photo.photo.photoGroupId:'anyone':context:contextId:600
          | async
      "
      ></lib-image-loader>
      @if (photo.photo.surcharge.surcharge) {
        <mat-icon
          class="ring surcharge"
      matTooltip="{{
        'clhqp94vs000008la40weh81o' | translate: 'productFront'|async
      }} +{{ photo.photo.surcharge.price | pricePicker }}"
          >paid
        </mat-icon>
      }
      @if (!photo.photo.check) {
        <mat-icon class="ring"></mat-icon>
      }
      @if (photo.photo.check) {
        <mat-icon class="ring checked"> done</mat-icon>
      }
    </div>
  </ng-template>

  <ng-template #messageAboutMaximumPhotos>
    <div class="centerPoint">
      <h1 translate>clhrgxa50000208mu9vcb8k7a</h1>
    </div>
  </ng-template>

  <ng-template #messageAboutTooManyPhotos>
    <div class="centerPoint">
      <h1 translate>clhrgxhzr000308mu0v9w18zz</h1>
    </div>
  </ng-template>

  <ng-template #messageAboutSurchargeForFile>
    <div class="centerPoint">
      <h1 translate>clhrgxnqs000408mu2jqe87ya</h1>
    </div>
  </ng-template>

  <ng-template #messageAboutNoMatchingFavoritePhotos>
    <div class="centerPoint">
      <h1 translate>clhrgxurf000508mufl8offrx</h1>
    </div>
  </ng-template>
